import MiniProductConnector from './miniProduct.props';
import MiniProductComponent from './miniProduct.component';

export default MiniProductConnector(MiniProductComponent);
